import { ActionButton, Tooltip, TooltipTrigger } from '@adobe/react-spectrum';
import { Labels } from '@jsonforms/core';
import HelpOutline from '@spectrum-icons/workflow/HelpOutline';
import React, { useEffect, useRef, useState } from 'react';
import { resolveContextValue } from '../util/commonUtils';

type ISpectrumInputLabel = {
  label: string | Labels;
  tooltip: string;
  maxLength: number;
  value: string;
  style: object;
  showMaxLength: boolean;
  alignTooltip?: 'left' | 'right';
  maxLengthMessage?: string,
};

const SpectrumInputLabel = ({
  label,
  tooltip,
  maxLength,
  value,
  style,
  showMaxLength,
  alignTooltip = 'left',
  maxLengthMessage
}: ISpectrumInputLabel) => {
  const labelRef = useRef(null);

  const [tooltipLeft, setTooltipLeft] = useState(0);

  // Align the tooltip to the left
  const leftAlign = alignTooltip === 'left';

  useEffect(() => {
    const calculateTooltipLeft = () => {
      const width = labelRef.current?.clientWidth || 0;
      if (width && leftAlign) {
        setTooltipLeft(width + 10);
      }
    };

    window.addEventListener('resize', calculateTooltipLeft);

    calculateTooltipLeft();

    return () => {
      window.removeEventListener('resize', calculateTooltipLeft);
    };
  }, []);

  let style1 = {};

  if (leftAlign) {
    style1 = { left: `${tooltipLeft}px` };
  }

  const tooltipJSX = tooltip && (
    <TooltipTrigger delay={0}>
      <ActionButton
        aria-label='hint'
        UNSAFE_style={{
          border: 'none',
          height: '16px',
        }}
      >
        <HelpOutline
          size='S'
          UNSAFE_style={{ position: 'absolute', top: '-2px' }}
        />
      </ActionButton>
      <Tooltip>
        <div dangerouslySetInnerHTML={{ __html: tooltip }}></div>
      </Tooltip>
    </TooltipTrigger>
  );
  const remainingLength = maxLength - (value?.length || 0)
  const maxLengthJSX = maxLength && showMaxLength && (
    maxLengthMessage ? resolveContextValue({ count: remainingLength }, maxLengthMessage) :
      <>{remainingLength}</>
  );

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span ref={labelRef} style={style}>
          {label}&nbsp;
        </span>
      </div>
      {leftAlign ? (
        <>
          <span style={{ position: 'absolute', right: 0, ...style1 }}>
            {tooltipJSX}
          </span>
          <span style={{ position: 'absolute', right: '0' }}>
            {maxLengthJSX}
          </span>
        </>
      ) : (
        <span style={{ position: 'absolute', right: '0', display: "inline-flex", gap: "4px" }}>
          <span>

            {maxLengthJSX}
          </span>

          {tooltipJSX}

        </span>
      )}
    </>
  );
};

export default SpectrumInputLabel;
